import { render, staticRenderFns } from "./Badge.vue?vue&type=template&id=03c06fcc&"
import script from "./Badge.vue?vue&type=script&lang=ts&"
export * from "./Badge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports